import { LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { IOsaExecucaoCustoEquipeModel } from '../models/osa-execucao-custo-equipe.model';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OsaExecucaoCustoEquipeService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public async obterPorExecucao(osaExecucaoId: number, secaoId?: number): Promise<IBaseModel<IOsaExecucaoCustoEquipeModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoCustoEquipeModel[]>>(`${this.apiBaseUrl}/OsaExecucaoCustoEquipe/${osaExecucaoId}/secao/${secaoId}`)
      .toPromise();
  }

  public obterPorId(id: number): Observable<IBaseModel<IOsaExecucaoCustoEquipeModel>> {
    return this.httpClient.get<IBaseModel<IOsaExecucaoCustoEquipeModel>>(`${this.apiBaseUrl}/${id}`);
  }

  public inserir(data: IOsaExecucaoCustoEquipeModel): Observable<IBaseModel<IOsaExecucaoCustoEquipeModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoCustoEquipeModel>>(`${this.apiBaseUrl}/OsaExecucaoCustoEquipe`, data);
  }

  public atualizar(data: IOsaExecucaoCustoEquipeModel): Observable<IBaseModel<IOsaExecucaoCustoEquipeModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoCustoEquipeModel>>(`${this.apiBaseUrl}/OsaExecucaoCustoEquipe`, data)
  }

  public excluir(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoCustoEquipe/${id}`)
  }
}